import { HTTP_ERROR_MESSAGE_COMPONENTS } from './const'
import { CustomHttpErrorMessageProps } from './type'

export const CustomHttpErrorMessage = ({
  message,
}: CustomHttpErrorMessageProps) => {
  const Component = HTTP_ERROR_MESSAGE_COMPONENTS[message]

  return <Component />
}
